
export interface GetPlaylistDto
{
    getToneCode(): string;
    getType(): string;
    getIsAll(): string;
    getContentTypeId(): string;
    getClientSessionId(): string;
    getLanguage(): string;
}

export class GetPlaylistDtoImpl implements GetPlaylistDto
{
    private toneCode: string;
    private type: string;
    private isAll: string;
    private contentTypeId: string;
    private clientSessionId: string;
    private language: string;

    getToneCode(): string
    {
        return this.toneCode;
    }
    setToneCode(toneCode: string)
    {
        this.toneCode = toneCode;
    }

    setType(type: string)
    {
        this.type = type;
    }
    getType(): string 
    {
        return this.type;
    }   

    setIsAll(isAll: string)
    {
        this.isAll = isAll;
    } 
    getIsAll(): string 
    {
        return this.isAll;
    }

    getContentTypeId(): string
    {
        return this.contentTypeId;
    }
    setContentTypeId(contentTypeId: string)
    {
        this.contentTypeId = contentTypeId;
    }

    getClientSessionId(): string
    {
        return this.clientSessionId;
    }
    setClientSessionId(clientSessionId: string)
    {
        this.clientSessionId = clientSessionId;
    }

    setLanguage(language: string)
    {
        this.language = language;
    }
    getLanguage(): string 
    {
        return this.language;
    }  
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/getplaylist/getplaylistdto.ts